import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPieChart3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPieChart3"><Path d="M11 12.4141L18.3281 19.7422C16.6043 21.1529 14.4013 22 12 22C6.47715 22 2 17.5228 2 12C2 6.81467 5.9467 2.55155 11 2.0498V12.4141Z" fill="currentColor"/><Path d="M21.541 8.99805C21.8389 9.9457 22 10.954 22 12C22 14.4013 21.1529 16.6043 19.7422 18.3281L13.751 12.3369L21.541 8.99805Z" fill="currentColor"/><Path d="M13 2.0498C16.3423 2.38166 19.1986 4.35975 20.751 7.16113L13 10.4834V2.0498Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPieChart3;
